import React, { useCallback, useEffect, useState } from "react";
import ClientPortalAppLayout from "../../Components/Molecules/ClientPortalAppLayout";
import Table, { Column, DataSourceItem } from "../../Components/Atoms/Table";
import { createSortFunction } from "../../Utils/TableUtils";
import { PaymentRoutes } from "../../Contracts/Routes";
import { useCustomerStore } from "../../Store/Customer";
import { usePagination, PAGINATION_KEYS } from "../../Store/Pagination";
import LoadingPage from "../LoadingPage";
import TablePaginationFooter from "../../Components/Atoms/Table/TablePaginationFooter";
import { CustomerForClientPortalView } from "../../Contracts/Customer";

const ClientPortalCustomerListPage: React.FC = () => {
  const [sortParamValue, setSortParamValue] = useState<string>("");

  const { limit, page, setLimit, setPage } = usePagination(
    PAGINATION_KEYS.CLIENT_PORTAL_CUSTOMER_LIST,
    { limit: 25, page: 1 }
  );

  const columns: Column<CustomerForClientPortalView>[] = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sortClicked: createSortFunction("name", setSortParamValue),
      render: d => (
        <a
          href={`${window.location.origin}${PaymentRoutes.CLIENT_PORTAL_CUSTOMERS}/${d.data.id}`}
          className="text-blue-600"
        >
          {d.data.name}
        </a>
      )
    },
    {
      title: "Preferred Payment method",
      dataIndex: "payment_method",
      key: "payment_method",
      render: d => <div className="capitalize">{d.payment_method}</div>
    },
    {
      title: "Open Invoices",
      dataIndex: "open_invoices",
      key: "open_invoices",
      sortClicked: createSortFunction("open_invoices_count", setSortParamValue)
    }
  ];

  const { isLoading, clientPortalCustomers, clientPortalCustomersCount, getClientPortalCustomers } =
    useCustomerStore();

  const refreshThings = useCallback(() => {
    getClientPortalCustomers(limit, sortParamValue, page);
  }, [getClientPortalCustomers, limit, sortParamValue, page]);
  useEffect(() => {
    refreshThings();
  }, [refreshThings, limit, sortParamValue, page]);

  const dataSource: DataSourceItem<CustomerForClientPortalView>[] = clientPortalCustomers.map(
    customer => ({
      key: customer.id.toString(),
      payment_method: customer.preferred_payment_method_type,
      open_invoices: customer.open_invoices_count === null ? 0 : customer.open_invoices_count,
      data: customer
    })
  );

  return (
    <ClientPortalAppLayout>
      <div className="flex flex-col h-[calc(100vh-9rem)]">
        <div
          className={`flex flex-grow flex-col ${
            clientPortalCustomers.length >= 14 ? "overflow-y-auto" : ""
          }`}
        >
          {isLoading && clientPortalCustomers.length === 0 ? (
            <LoadingPage />
          ) : (
            <Table dataSource={dataSource} columns={columns} isLoading={isLoading} />
          )}
        </div>
        <TablePaginationFooter
          limit={limit}
          setLimit={setLimit}
          setPage={setPage}
          totalRecords={clientPortalCustomersCount}
          page={page}
          isLoading={isLoading}
        />
      </div>
    </ClientPortalAppLayout>
  );
};

export default ClientPortalCustomerListPage;
